import React, { useState, useEffect } from "react";
import { FaEdit } from "react-icons/fa";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import "../components/User.css";
// import { authFetch } from '../utils/auth.js';

function UserPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchUsers();
  }, []);

  const getAuthToken = () => localStorage.getItem('session_token') || '';

  async function fetchUsers() {
    try {
      setLoading(true);
      const token = getAuthToken();
      const url = `https://newerp.awasthivitality.com/api/user/list${token ? `?token=${encodeURIComponent(token)}` : ''}`;
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      setUsers(data.data || []);
    } catch (err) {
      console.error("Failed to fetch users:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
    
  }

  const handleSearchChange = (e) => setSearchTerm(e.target.value);
  const handleReset = () => setSearchTerm("");

  const handleAddUserClick = () => navigate('/AddUserPage');
  const handleEditClick = (user_id) => navigate(`/EditUserPage/${user_id}`);

  const handleToggleStatus = async (user_id) => {
    try {
      const token = getAuthToken();
      const response = await fetch(`https://newerp.awasthivitality.com/api/user/toggle-status/${user_id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });
      if (!response.ok) throw new Error(`Failed to toggle status, status code: ${response.status}`);
      await response.json();

      setUsers(prev =>
        prev.map(u =>
          u.user_id === user_id
            ? {
              ...u,
              status: u.status === 0 ? 1 : 0,
              status_text: u.status === 0 ? "Disable" : "Enable",
              status_class: u.status === 0 ? "btn-danger" : "btn-primary",
              status_button_text: u.status === 0 ? "Disable" : "Enable"
            }
            : u
        )
      );
    } catch (err) {
      console.error(err);
      alert(`Error toggling status: ${err.message}`);
    }
  };

  const filteredUsers = users.filter(u =>
    (u.user_type || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (u.user_name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (u.user_branch || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <div className="usrpg-container container"><p>Loading users...</p></div>;
  if (error) return <div className="usrpg-container container"><p>Error loading users: {error}</p></div>;

  return (
    <div className="usrpg-container container">
      <div className="usrpg-card card">
        <div className="usrpg-card-header card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">User Information</h5>
          <button className="usrpg-add-btn btn btn-light" onClick={handleAddUserClick}>+</button>
        </div>
        <div className="card-body">
          <div className="mb-3 d-flex gap-2">
            <input
              type="text"
              className="form-control"
              placeholder="Search by User Type or User Name"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <button className="btn btn-secondary" onClick={handleReset}>Reset</button>
          </div>
          <div className="usrpg-table-wrapper">
            <table className="usrpg-table table table-bordered">
              <thead>
                <tr>
                  <th>S No</th>
                  <th>User Type</th>
                  <th>User Branch</th>
                  <th>User Name</th>
                  <th>Password</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.length > 0 ? filteredUsers.map((user, index) => (
                  <tr key={user.user_id}>
                    <td>{index + 1}</td>
                    <td>{user.user_type}</td>
                    <td>{user.user_branch}</td>

                    <td>{user.user_name}</td>
                    <td>{user.password}</td>
                    <td>
                      <button
                        className={`usrpg-status-btn btn btn-sm ${user.status_class || 'btn-primary'}`}
                        onClick={() => handleToggleStatus(user.user_id)}
                      >
                        {user.status_button_text || (user.status === 0 ? "Enable" : "Disable")}
                      </button>
                    </td>
                    <td>
                      <button
                        className="usrpg-action-btn btn btn-outline-primary btn-sm"
                        onClick={() => handleEditClick(user.user_id)}
                        type="button"
                      >
                        <FaEdit />
                      </button>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="6" className="usrpg-no-users">No users found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserPage;